import React, { useEffect, useState } from "react";
import AdsServiceCard from "../../../../components/common/adsServiceCard";
import { getAds } from "../../../../api/ads";
import { Pagination, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PendingAdsComp from "../../../../components/common/pendingAdCard";

const CurrentAds = () => {
  const [allAds, setAllAds] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [pageSize, setPagesize] = useState(4);
  const fetchData = async () => {
    setLoader(true);
    const filter = "APPROVED";
    const res = await getAds(currentPage, pageSize, filter);
    setAllAds(res);
    setLoader(false);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize]);
  const onlyApprovedAds = allAds?.items?.filter(
    (item) => item?.isApproved === "APPROVED"
  );
  if ((!loader && !onlyApprovedAds) || onlyApprovedAds?.length === 0) {
    return (
      <div className="text-xl flex justify-center h-screen items-center opacity-50">
        No Live Ads...
      </div>
    );
  }
  return (
    <>
      {loader ? (
        <div className="flex h-screen justify-center items-center">
          <Spin
            indicator={<LoadingOutlined />}
            className="flex justify-center"
            size="large"
          />
        </div>
      ) : (
        <div className=" w-full">
          <div className="w-full">
            {onlyApprovedAds?.map((item, i) => (
              <div
                className=" m-2 gap-2 grid grid-cols-1 lg:grid-cols-4 "
                key={i}
              >
                <div className="col-span-1">
                  <AdsServiceCard data={item} />
                </div>
                <div className="col-span-3">
                  <PendingAdsComp isHomePage={true} data={item} />
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-center items-center pagination-container mb-2">
            <Pagination
              current={currentPage}
              total={onlyApprovedAds?.length}
              pageSize={pageSize}
              pageSizeOptions={[4, 10, 20, 30]}
              onShowSizeChange={handleSizeChange}
              onChange={(e) => {
                handlePageChange(e);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default CurrentAds;
